import React, { useState } from "react";
import CreateTopUpForm from "./CreateTopUpForm";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import ReactHotToaster from "../../common/ReactHotToaster";
import { axiosConfig } from "../../../axios/axiosConfig";
import TopUpsTable from "./TopUpsTable";
import MuiModal from "../../muiComps/MuiModal";
import { useSelector } from "react-redux";
import { Box, Button, Typography } from "@mui/material";
import AddCardIcon from "@mui/icons-material/AddCard";

const CreateTopUp = () => {
  const { user } = useSelector((state) => state.auth);
  const USERID = user?.userDetails?.id;

  const [allTopUpDetails, setAllTopUpDetails] = useState([]);
  const [openTopUpForm, setOpenTopUpForm] = useState(false);
  const [activeTopUp, setActiveTopUp] = useState({});

  // fetch all subscription plans
  const fetchAllTopUpsQuery = useQuery({
    retry: false,
    refetchOnWindowFocus: false, // Prevent refetch on window focus
    refetchInterval: false, // Disable automatic refetching
    queryKey: ["all-topups"], // dependency
    queryFn: () => fetchAllTopUps(USERID),
    onSuccess: (data) => {
      setAllTopUpDetails(data.response);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.response || "Something went wrong");
    },
  });

  const openCreateTopUpModals = () => {
    setActiveTopUp({});
    setOpenTopUpForm(true);
  };

  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <AddCardIcon sx={{ color: "#fff", fontSize: 32 }} />
          <Box>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
              Top-Up Plans
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
              Manage top-up plans
            </Typography>
          </Box>
        </Box>
        <Button
          onClick={openCreateTopUpModals}
          sx={{
            background: "linear-gradient(135deg, #016551, #014d3d)",
            color: "#fff",
            fontWeight: 600,
            borderRadius: "8px",
            px: 3,
            boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
            "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
          }}
        >
          Create TopUp
        </Button>
      </Box>

      {/* TopUps Table */}
      <TopUpsTable
        topUpsData={allTopUpDetails}
        setOpenTopUpForm={setOpenTopUpForm}
        setActiveTopUp={setActiveTopUp}
      />

      {/* TopUp form modal */}
      <MuiModal open={openTopUpForm} setOpen={setOpenTopUpForm}>
        <CreateTopUpForm
          formType={Object.keys(activeTopUp).length ? "edit" : "create"}
          activeTopUp={activeTopUp}
          setAllTopUpDetails={setAllTopUpDetails}
          setOpenTopUpForm={setOpenTopUpForm}
        />
      </MuiModal>

      {/* REACT HOT TOAST */}
      <ReactHotToaster />
    </Box>
  );
};

export default CreateTopUp;

// UTILITY FUNCTIONS
export const fetchAllTopUps = async (USERID) => {
  if (!USERID) return;

  const res = await axiosConfig({
    method: "get",
    url: `/subscription/topup_plan?userid=${USERID}`,
    data: {},
  });

  return res.data;
};
